import React from 'react';
import pattern from './pattern.png'
import './Pattern.css'

function Pattern(){
    return(
           
         <img src={pattern} alt="pattern" className="pattern-img"/>  
    )
}

export default Pattern